/**
 * An inherted class from Request Service which supports throttling.
 */

import {REQUEST_THROTTLE} from "../constants";
import {nsRequest} from "./fn";
import {global} from "../appContext";
import PromiseRequest from "./PromiseRequest";
import {IPromiseRequestOptions} from "./index";

export class PromiseRequestThrottle extends PromiseRequest {

    private timeoutId!: number;

    public override request(params: any = {}, fullResponse: boolean = false, settings: JQuery.AjaxSettings = {}, options?: IPromiseRequestOptions, throttleDuration: number = REQUEST_THROTTLE): Promise<any> {
        if (this.jqXHR) {
            this.abort()
        }
        clearTimeout(this.timeoutId)
        const p = nsRequest.getParams(this.serviceName, params);
        const cache = global.cacheManager.getCache(this.serviceName, p, fullResponse);
        if (throttleDuration == 0 || cache) {
            return super.request(params, fullResponse, settings)
        } else {
            this.isRequesting(true)
            return new Promise((executor: Function, reject: Function) => {
                this.timeoutId = setTimeout(() => {
                    super.request(params, fullResponse, settings, options)
                        .then((data: any) => {
                            executor(data)
                        })
                        .catch((reason: string) => reject(reason))
                }, throttleDuration);
            })
        }
    }

}